/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2585
 */

var r = require(/* 502 */"./502/index")
module.exports = function () {
  return r.Date.now()
}
